document.addEventListener('DOMContentLoaded', () => {
  const accordionBtns = document.querySelectorAll('.js-accordion-toggle');

  accordionBtns.forEach((btn) => {
    btn.addEventListener('click', (e)=> {
      e.preventDefault;

      const parent = btn.closest('.js-accordion-item');

      // grab panel
      const panel = parent?.querySelector<HTMLElement>('.js-accordion-panel') ??
        parent?.querySelector<HTMLElement>('.ais-Panel-body');

      if (panel?.classList.contains('open')) {
        btn.classList.remove('open');
        panel.style.maxHeight = '0';
        panel.classList.remove('open');
        panel.setAttribute('aria-hidden', 'true');
      } else if (panel) {
        btn.classList.add('open');
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.classList.add('open');
        panel.removeAttribute('aria-hidden');
      }
    });
  });
});
